import { Form, Formik, FormikHelpers, FormikProps, FormikTouched, FormikValues } from "formik";
import { useSharedStyles } from "../../common/sharedStyles";
import { ErrorFocus } from "../controls/helpers";

interface Props<Values> {
  children?: ((props: FormikProps<Values>) => React.ReactNode) | React.ReactNode;
  enableReinitialize?: boolean;
  enterSubmits?: boolean;
  initialTouched?: FormikTouched<Values>;
  initialValues: Values;
  validationSchema?: any;
  onSubmit: (values: Values, formikHelpers: FormikHelpers<Values>) => void | Promise<unknown>;
}

const FormikWrapper = <Values extends FormikValues>({ children, enableReinitialize, enterSubmits, initialTouched, initialValues, onSubmit, validationSchema }: Props<Values>) => {
  const sharedClasses = useSharedStyles();
  return (
    <Formik enableReinitialize={enableReinitialize} initialTouched={initialTouched} initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
      {(formik) => (
        <Form className={sharedClasses.form} onKeyDown={(e) => !enterSubmits && (e.code === "Enter" || e.code === "NumpadEnter") && e.preventDefault()}>
          <ErrorFocus />
          {typeof children === "function" ? children(formik) : children}
        </Form>
      )}
    </Formik>
  );
};

export default FormikWrapper;
